import { useEffect } from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
  useRouteError,
} from "react-router-dom";
import ScrollToTop from "../components/scrollToTop/scrollToTop";
import Login from "../views/dashboard/login/login";
import Admin from "../views/dashboard/admin/admin";
import Error404 from "../components/error404/error404";
import GuiaDeEstilos from "../views/guia-de-estilos/main";
import Assignment from "../views/dashboard/admin/export/assignment/assignment";
import AssignmentReservation from "../views/dashboard/admin/export/assignment/assignment-reservation";
import { montacargasRoute } from "../views/montacargas/routes";
import { isMontacargasRoute } from "../views/montacargas/registerMontacargasPwa";
import { reportErrorToBackend } from "../components/errorBoundary/ErrorBoundary";

// Componente para capturar y reportar errores de las rutas
const RouteErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => {
    // Reportamos el error al backend automáticamente
    if (error) {
      reportErrorToBackend(error);
    }
  }, [error]);

  // Reutilizamos el componente 404 o podrías usar uno específico para errores 500
  return <Error404 />;
};

// Si la app arranca dentro de /montacargas, el router SOLO conoce esas
// rutas: el resto del sistema (dashboard, assignment, guía de estilos, etc.)
// ni siquiera se registra, así que no hay forma de navegar hacia allá desde
// dentro de la PWA de montacargas (ni siquiera por bug o URL a mano dentro
// de la SPA). Ver src/index.js: por la misma razón /montacargas queda fuera
// del Auth0Provider, y montar esas rutas ahí terminaría en un crash en vez
// de una fuga de acceso.
const router = createBrowserRouter(
  isMontacargasRoute()
    ? [
        {
          ...montacargasRoute,
          errorElement: <RouteErrorBoundary />,
        },
        {
          path: "*",
          element: <Navigate to="/montacargas" replace />,
        },
      ]
    : [
        {
          path: "/",
          element: <Login />,
          errorElement: <RouteErrorBoundary />,
        },
        {
          path: "/guia-de-estilos",
          element: <GuiaDeEstilos />,
          errorElement: <RouteErrorBoundary />,
        },
        {
          path: "/dashboard",
          errorElement: <RouteErrorBoundary />,
          children: [
            {
              path: "",
              element: <Navigate to="/" replace />,
            },
            {
              path: "login",
              element: <Login />,
            },
            {
              path: "admin",
              element: <Admin />,
            },
          ],
        },

        {
          path: "/assignment",
          element: <Assignment />,
          errorElement: <RouteErrorBoundary />,
        },
        {
          path: "/assignment-reservation",
          element: <AssignmentReservation />,
          errorElement: <RouteErrorBoundary />,
        },
        {
          ...montacargasRoute,
          errorElement: <RouteErrorBoundary />,
        },
      ],
);

const MyRoutes = () => (
  <RouterProvider router={router}>
    <ScrollToTop />
  </RouterProvider>
);

export default MyRoutes;
